import { Button, HorizontalCard, Input } from '@atlas/ui-kit'
import { FieldCaption } from './DetailsCard'

const SHAREPOINT_LABEL = 'SharePoint delivery folder URL'

/** The order's Veeva Distribution Package, as Reference material links it. */
export interface PackageCode {
	code: string
	/** Its Vault document. */
	href: string
}

/**
 * Reference material, the Task Details card's second section: where the piece comes from (the
 * Veeva Distribution Package) and where it is delivered (the SharePoint folder). The PM types
 * the folder URL; read-only, it is a card with a copy action.
 */
export function ReferenceMaterial({
	packageCode,
	sharepointUrl,
	onSharepointUrlChange,
	sharepointError,
	onCopy,
}: {
	packageCode: PackageCode | null
	sharepointUrl: string
	/** Absent when the folder URL is read-only. */
	onSharepointUrlChange?: (value: string) => void
	/** Why the typed URL cannot be saved. */
	sharepointError?: string | null
	onCopy: (value: string) => void
}) {
	return (
		<section aria-label="Reference material" className="flex flex-col gap-2">
			{packageCode ? (
				<HorizontalCard
					variant="dp-link"
					label="Veeva Distribution Package code"
					value={packageCode.code}
					onCopyValue={onCopy}
					copyLabel={`Copy ${packageCode.code}`}
					actionLabel="Open in Veeva"
					actionHref={packageCode.href}
				/>
			) : null}
			{onSharepointUrlChange ? (
				<div className="flex flex-col gap-1">
					<div className="flex flex-col gap-1">
						<FieldCaption label={SHAREPOINT_LABEL} />
						<Input
							aria-label={SHAREPOINT_LABEL}
							type="url"
							value={sharepointUrl}
							placeholder="https://"
							aria-invalid={sharepointError ? true : undefined}
							onChange={(event) => onSharepointUrlChange(event.target.value)}
						/>
					</div>
					{sharepointError ? <span className="text-atlas-label text-atlas-error">{sharepointError}</span> : null}
					{sharepointUrl.trim() ? (
						<Button variant="text-link" className="self-start" onPress={() => onCopy(sharepointUrl.trim())}>
							Copy URL
						</Button>
					) : null}
				</div>
			) : sharepointUrl ? (
				<HorizontalCard
					variant="copy-url"
					label={SHAREPOINT_LABEL}
					value={sharepointUrl}
					onCopyValue={onCopy}
					copyLabel="Copy the SharePoint URL"
				/>
			) : null}
		</section>
	)
}
